import React, { useRef } from 'react';
import classNames from 'classnames';
import getElementWidthHoc from '../../../hoc/getElementWidthHoc';
import { PROFILE_CARD_WIDTH } from '../../profileCard/components/ProfileCard';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import { millisecondToISODate } from '../../../common/utils';
import { columnProfilingToPDF } from '../../../diagrams/export/columnProfilingToPDF';
import { PdfExportOverlay } from '../../../diagrams/export/PdfExportOverlay';
import AccurityIconButton from '../../../buttons/components/AccurityIconButton';
var COLUMN_GAP_WIDTH = 10;
var ColumnProfilingCanvas = function (_a) {
    var _b = _a.children, children = _b === void 0 ? [] : _b, width = _a.width, columnName = _a.columnName, openDetail = _a.openDetail, showOpenDetailButton = _a.showOpenDetailButton, closeCanvas = _a.closeCanvas, profiledAt = _a.profiledAt, profiledBy = _a.profiledBy;
    var diagramExporterRef = useRef();
    var numberOfColumns = width > 2 * PROFILE_CARD_WIDTH + COLUMN_GAP_WIDTH ? 2 : 1;
    var handleDownloadToPdf = function () {
        var elm = document.querySelector('.columnProfilingCanvas__exporter');
        if (diagramExporterRef.current && elm) {
            var exportFunction = function () { return columnProfilingToPDF(elm, columnName); };
            diagramExporterRef.current.export(exportFunction);
        }
    };
    return (React.createElement(PdfExportOverlay, { ref: diagramExporterRef, className: "columnProfilingCanvas__exporter", constructStyle: function (isAutoHeight) { return ({ height: isAutoHeight ? 'unset' : '100%' }); } },
        React.createElement("div", { className: "columnProfilingCanvas__header" },
            React.createElement("div", { className: "columnProfilingCanvas__headerLeftNodes" },
                React.createElement(AccurityIcon, { iconName: "dataProfile", className: "columnProfilingCanvas__icon" }),
                React.createElement("div", { className: "columnProfilingCanvas__title" },
                    "Profile of ",
                    columnName),
                React.createElement("div", { className: "columnProfilingCanvas__subtitle" },
                    "Last Profiled at ",
                    millisecondToISODate(profiledAt),
                    " by ",
                    profiledBy.name)),
            React.createElement("div", { className: "columnProfilingCanvas__headerRightNodes" },
                showOpenDetailButton && !!openDetail && (React.createElement(AccurityIconButton, { onClick: function () { return openDetail(); }, iconName: "mui:ViewSidebarOutlined", title: "Open detail" })),
                React.createElement(AccurityIconButton, { iconName: "mui:CloudDownloadOutlined", size: "small", title: "Export to PDF", onClick: handleDownloadToPdf }),
                !!closeCanvas && (React.createElement(AccurityIconButton, { iconName: "mui:Close", size: "small", onClick: closeCanvas })))),
        React.createElement("div", { className: "columnProfilingCanvas__contentContainer" },
            React.createElement("div", { className: classNames('columnProfilingCanvas__content', { 'columnProfilingCanvas__content--twoColumns': numberOfColumns === 2 }) }, React.Children.toArray(children).map(function (child, idx) {
                return (React.createElement("div", { className: "columnProfilingCanvas__contentItem", key: idx }, child));
            })))));
};
export default getElementWidthHoc(ColumnProfilingCanvas, {
    className: 'columnProfilingCanvas'
});
//# sourceMappingURL=ColumnProfilingCanvas.js.map